import { PaymentTerms } from './enums'

// NOTE: This codes are from SAP. Any change in the codes in SAP must be updated here.
export const PAYMENT_TERM_CASH_CODE = PaymentTerms.AV01
